export default {"src":"/_next/static/media/apron.99b1c3b1.svg","height":190,"width":186,"blurWidth":0,"blurHeight":0};